import { useEffect, useState } from 'react';

/** Presentation is acknowledged only while the actual review surface is visible. */
export function useActionVisibility() {
  const [element, setElement] = useState<HTMLDivElement | null>(null);
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    setVisible(false);
    if (!element) return;
    if (typeof IntersectionObserver === 'undefined') {
      // Older WebViews still get a geometric check; hidden elements have no rects.
      const check = () => {
        const box = element.getBoundingClientRect();
        setVisible(element.getClientRects().length > 0 && box.bottom > 0 && box.top < innerHeight);
      };
      check();
      window.addEventListener('scroll', check, true);
      window.addEventListener('resize', check);
      return () => {
        window.removeEventListener('scroll', check, true);
        window.removeEventListener('resize', check);
      };
    }
    const observer = new IntersectionObserver(([entry]) =>
      setVisible(entry?.isIntersecting === true),
    );
    observer.observe(element);
    return () => observer.disconnect();
  }, [element]);
  return { element, ref: setElement, visible };
}
